import * as React from "react";

function SvgIcons8EmptyBox(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M15.281 6a.987.987 0 00-.437.219L4.625 14.062l-.031.032h-.032a1.065 1.065 0 00-.218.156l-.032.031a.466.466 0 00-.062.031v.032a.949.949 0 00-.094.125.466.466 0 00-.031.062l-.031.031c-.024.051-.047.102-.063.157L.094 22.563c-.196.386-.121.851.183 1.16.309.304.774.379 1.16.183L4 22.625V43c0 .55.45 1 1 1h30.031c.063-.004.125-.016.188-.031.031-.008.062-.02.093-.032a.986.986 0 00.344-.187.472.472 0 00.063-.063.472.472 0 00.062-.062l.063-.094a.472.472 0 00.062-.062l7.875-9.844c.14-.176.219-.398.219-.625v-9.563l5.719-5.718a.997.997 0 00.125-1.219L44 6.781a.987.987 0 00-.219-.437.466.466 0 00-.031-.063h-.031a.466.466 0 00-.032-.062h-.03a.472.472 0 00-.063-.063c-.07-.039-.14-.07-.219-.093a.466.466 0 00-.063-.032h-.03A.466.466 0 0043.218 6H15.28zm.5 2h24.782l-6 6H7.936zm27.032.625l4.937 8.188-6.563 6.562-4.937-8.188zM6 16h28v26H6V21.125A.668.668 0 006 21zm30 2.563l4.156 6.937c.153.266.422.45.727.492.304.043.613-.058.836-.273l.281-.282v7.22l-6 7.5zM4 19.25v1.125l-.75.375zm10.719.75c-.551.078-.938.59-.86 1.14.079.551.59.938 1.141.86h10c.36.004.695-.184.879-.496a1.01 1.01 0 000-1.008c-.184-.312-.52-.5-.879-.496H14.719z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8EmptyBox);
